// TODO UPDATE AT REGENTS ADMIN FLIP: Make sure this is up-to-date each Regents Admin
// If next regents admin is 'Aug' user G'
// If next regents admin is 'Jan' user R'
// If next regents admin is 'June' user E'
export const NextRegentsAdminDateLetter = 'E';
